import type { SVGProps } from 'react'
const SvgLeftArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.70919 9.87921L2.82919 5.99921L6.70919 2.11921C6.87301 1.92791 6.95862 1.68183 6.9489 1.43015C6.93918 1.17848 6.83485 0.939738 6.65675 0.761644C6.47866 0.583549 6.23992 0.479217 5.98824 0.469496C5.73656 0.459775 5.49049 0.545381 5.29919 0.709207L0.709186 5.29921C0.522936 5.48657 0.418394 5.74002 0.418394 6.00421C0.418394 6.26839 0.522936 6.52185 0.709186 6.70921L5.29919 11.2992C5.48655 11.4855 5.74 11.59 6.00419 11.59C6.26837 11.59 6.52182 11.4855 6.70919 11.2992C6.89439 11.1093 6.99805 10.8545 6.99805 10.5892C6.99805 10.3239 6.89439 10.0691 6.70919 9.87921Z"
      fill={props.color ? props.color : '#1565C0'}
    />
  </svg>
)
export default SvgLeftArrow
